(function ($) {
  const queryParamsElements = $("div[data-query-params]").get();

  for (const queryParamsElement of queryParamsElements) {
    if (!queryParamsElement) return;
    const listId = $(queryParamsElement).attr("data-grid-wrapper-id");
    if (!listId) return;
    const sortbyElement = $(`#${listId} #sortby-select`);
    const sortbySummaryTextElement = $(
      `#${listId} #sortby-select .custom-select-summary-text`,
    );

    const sortbyButtons = sortbyElement.get(0)
      ? $(`#${listId} #sortby-select button`)
      : $(`#${listId} button[data-sort-by]`);

    let processing = false;

    $(sortbyButtons).click(function (event) {
      const sortBy = $(this).attr("data-sort-by");
      const sortByCustomField = $(this).attr("data-sort-by-custom-field");
      const sortOrder = $(this).attr("data-sort-order");
      const sortByCategory = $(this).attr("data-sort-by-category");
      const sortNumeric = $(this).attr("data-sort-numeric");

      sortPosts(
        sortBy,
        sortByCustomField,
        sortOrder,
        sortByCategory,
        sortNumeric,
      );

      const buttonText = $(this).text();
      $(sortbyButtons).parent().removeClass("active");
      $(this).attr("data-sort-order", sortOrder === "ASC" ? "DESC" : "ASC");

      $(this).parent().addClass("active");
      if (sortbySummaryTextElement) {
        $(sortbySummaryTextElement).empty();
        $(sortbySummaryTextElement).append(`Sort by ${buttonText}`);
      }
    });

    function sortPosts(
      sortBy,
      sortByCustomField,
      sortOrder,
      sortByCategory,
      sortNumeric,
    ) {
      const prevSortBy = $(queryParamsElement).attr("data-sort-by");
      const prevSortOrder = $(queryParamsElement).attr("data-sort-order");

      if (
        processing ||
        (sortBy === prevSortBy && sortOrder === prevSortOrder)
      ) {
        $(sortbyElement).removeAttr("open");
        return;
      }

      /* ====== Scroll Theme columns back ========== */
      $(`#${listId} .theme-columns`).scrollLeft(0);

      processing = true;
      $(sortbyElement).addClass("processing");
      $(sortbyElement).removeAttr("open");

      const listElement = document.querySelector(`#${listId} .posts-grid`);
      const noResultsElement = document.querySelector(`#${listId} .no-results`);
      const paginationElement = document.querySelector(
        `#${listId} .pagination`,
      );
      const originalArgs =
        queryParamsElement.querySelector("[data-query-args]")?.innerText;
      const ajaxUrl = siteConfig?.ajaxUrl ?? "";
      const ajaxNonce = siteConfig?.ajaxNonce ?? "";

      if (!sortbyElement || !ajaxUrl || !ajaxNonce || !originalArgs) return;

      const ajax = $(queryParamsElement).attr("data-ajax-query") === "true";
      const categoryId = $(queryParamsElement).attr("data-category-id") ?? "";
      const engagement = $(queryParamsElement).attr("data-engagement") ?? "";
      const gridId = $(queryParamsElement).attr("data-grid-id") ?? "";
      const gridClass = $(queryParamsElement).attr("data-grid-class") ?? "";
      const lazy = $(queryParamsElement).attr("data-lazy-query") === "true";
      const noResultsText =
        $(queryParamsElement).attr("data-no-results-text") ?? "";
      const prevNextLinks =
        $(queryParamsElement).attr("data-prev-next-links") === "true";
      const query = $(queryParamsElement).attr("data-query-string") ?? "";
      const sectionId =
        $(queryParamsElement).attr("data-grid-wrapper-id") ?? "";
      const templateArgs = queryParamsElement.querySelector(
        "[data-template-args]",
      )?.innerText;
      const templateKey = $(queryParamsElement).attr("data-template-key") ?? "";
      const termId = $(queryParamsElement).attr("data-term-id") ?? "";

      $.ajax({
        url: ajaxUrl,
        type: "post",
        data: {
          action: "search_posts",
          ajax,
          ajax_nonce: ajaxNonce,
          args: JSON.parse(originalArgs || "{}"),
          category_id: categoryId,
          engagement,
          grid_id: gridId,
          grid_class: gridClass,
          lazy,
          no_results_text: noResultsText,
          prev_next_links: prevNextLinks,
          query,
          section_id: sectionId,
          sort_by: sortBy,
          sort_by_category: sortByCategory,
          sort_by_custom_field: sortByCustomField,
          sort_numeric: sortNumeric,
          sort_order: sortOrder,
          template_args: JSON.parse(templateArgs || "{}"),
          template_key: templateKey,
          term_id: termId,
        },
        success: (response) => {
          $(document).scrollTop(1250);
          $(".scroll-columns").scrollLeft(0);

          if (!response || response.success === false) return;
          if (!!listElement) {
            $(listElement).parent().append(response);
            $(listElement).remove();
            if (paginationElement) $(paginationElement).remove();
          } else if (!!noResultsElement) {
            $(noResultsElement).parent().append(response);
            $(noResultsElement).remove();
          }
          processing = false;
          $(sortbyElement).removeClass("processing");
          $(queryParamsElement).attr("data-sort-by", sortBy);
          $(queryParamsElement).attr(
            "data-sort-by-custom-field",
            sortByCustomField,
          );
          $(queryParamsElement).attr("data-sort-order", sortOrder);
        },
        error: (error) => {
          console.error(error);
          processing = false;
          $(sortbyElement).removeClass("processing");
          $(queryParamsElement).attr("data-sort-by", sortBy);
          $(queryParamsElement).attr(
            "data-sort-by-custom-field",
            sortByCustomField,
          );
          $(queryParamsElement).attr("data-sort-order", sortOrder);
        },
      });
    }
  }
})(jQuery);
